import OrdersView from '@/views/OrdersView.vue';
import OrderAddView from '@/views/OrderAddView.vue';
import UsersView from '@/views/UsersView.vue';
import UserView from '@/views/UserView.vue';
import VehiclesView from '@/views/VehiclesView.vue';
import VehicleView from '@/views/VehicleView.vue';
import VehicleModelsView from '@/views/VehicleModelsView.vue';
import VehicleModelView from '@/views/VehicleModelView.vue';
import VehicleManufacturersView from '@/views/VehicleManufacturersView.vue';
import VehicleManufacturerView from '@/views/VehicleManufacturerView.vue';
import ItemsView from '@/views/ItemsView.vue';
import ItemView from '@/views/ItemView.vue';
import EmployeesView from '@/views/EmployeesView.vue';
import EmployeeView from '@/views/EmployeeView.vue';
import ServiceJobsView from '@/views/ServiceJobsView.vue';
import ServiceJobView from '@/views/ServiceJobView.vue';
import ServiceJobOperationsView from '@/views/ServiceJobOperationsView.vue';
import ServiceJobOperationView from '@/views/ServiceJobOperationView.vue';
import ServiceJobComponentsView from '@/views/ServiceJobComponentsView.vue';
import ServiceJobComponentView from '@/views/ServiceJobComponentView.vue';
import ServiceJobComponentGroupsView from '@/views/ServiceJobComponentGroupsView.vue';
import ServiceJobComponentGroupView from '@/views/ServiceJobComponentGroupView.vue';
import ServiceJobCategoriesView from '@/views/ServiceJobCategoriesView.vue';
import ServiceJobCategoryView from '@/views/ServiceJobCategoryView.vue';
import ServiceJobGroupsView from '@/views/ServiceJobGroupsView.vue';
import ServiceJobGroupView from '@/views/ServiceJobGroupView.vue';
import CounterpartiesView from '@/views/CounterpartiesView.vue';
import CounterpartyView from '@/views/CounterpartyView.vue';
import ItemsGroupsView from '@/views/ItemsGroupsView.vue';
import ItemsGroupView from '@/views/ItemsGroupView.vue';
import ScheduleView from '@/views/ScheduleView.vue';

/** Single source of truth: normalized view name -> component. Ensures exactly one component per tab. */
const VIEWS: Record<string, object> = {
	orders: OrdersView as object,
	orderadd: OrderAddView as object,
	order: OrderAddView as object,
	users: UsersView as object,
	user: UserView as object,
	vehicles: VehiclesView as object,
	vehicle: VehicleView as object,
	vehiclemodels: VehicleModelsView as object,
	vehiclemodel: VehicleModelView as object,
	vehiclemanufacturers: VehicleManufacturersView as object,
	vehiclemanufacturer: VehicleManufacturerView as object,
	items: ItemsView as object,
	item: ItemView as object,
	employees: EmployeesView as object,
	employee: EmployeeView as object,
	jobs: ServiceJobsView as object,
	job: ServiceJobView as object,
	joboperations: ServiceJobOperationsView as object,
	joboperationadd: ServiceJobOperationView as object,
	joboperationview: ServiceJobOperationView as object,
	jobcomponents: ServiceJobComponentsView as object,
	jobcomponentadd: ServiceJobComponentView as object,
	jobcomponentview: ServiceJobComponentView as object,
	jobcomponentgroups: ServiceJobComponentGroupsView as object,
	jobcomponentgroupadd: ServiceJobComponentGroupView as object,
	jobcomponentgroupview: ServiceJobComponentGroupView as object,
	jobcategories: ServiceJobCategoriesView as object,
	jobcategoryadd: ServiceJobCategoryView as object,
	jobcategoryview: ServiceJobCategoryView as object,
	jobgroups: ServiceJobGroupsView as object,
	jobgroupadd: ServiceJobGroupView as object,
	jobgroupview: ServiceJobGroupView as object,
	counterpatries: CounterpartiesView as object,
	counterparty: CounterpartyView as object,
	itemsgroups: ItemsGroupsView as object,
	itemsgroup: ItemsGroupView as object,
	schedule: ScheduleView as object,
};

export default VIEWS;